import { useLocation } from 'react-router-dom'
import { PropsWithChildren } from 'react'

import * as S from './styles'

function getFirstPathSegment(pathname: string): string | null {
  const segments = pathname.split('/').filter(Boolean)
  return segments[0] ?? null
}

export const StepbarWrapper = ({ children }: PropsWithChildren) => {
  const pathname = useLocation().pathname
  const pathSegment = getFirstPathSegment(pathname)

  const STEPBAR_VISIBLE_PATH_SEGMENTS = [
    null,
    'local',
    'fallback',
    'paciente',
    'pagamento',
    'escolha-usuario',
    'agendar-consulta',
    'confirmar-paciente',
    'confirmar-horario'
  ]

  const EXCLUDED_PATHS = [
    'teleconsulta-do-paciente-expirada',
    'teleconsulta-do-medico-expirada',
    'teleconsulta-cancelada',
    'consulta-cancelada',
    'consulta-expirada'
  ]

  const showStepbar =
    STEPBAR_VISIBLE_PATH_SEGMENTS.includes(pathSegment) &&
    !EXCLUDED_PATHS.some((excludedPath) => pathname.includes(excludedPath))

  if (!showStepbar) {
    return null
  }

  return (
    <S.Wrapper>
      <S.Content>{children}</S.Content>
    </S.Wrapper>
  )
}
